import {createFeatureSelector, createSelector} from '@ngrx/store'
import {Features} from '../../features';
import {DaneKlienta} from '../../../services/samoobsluga/types/dane-klienta';

export const daneKlientaSelector = createFeatureSelector<DaneKlienta>(Features.DANE_KLIENTA);

export const czyPosiadaNumerKontaSelector = createSelector(
  daneKlientaSelector, (daneKlienta: DaneKlienta) => daneKlienta.czyPosiadaNumerKonta
)
